import { FC } from 'react';
import { Container } from 'react-bootstrap';
import { FiGithub, FiLinkedin } from 'react-icons/all';

import './ClDrawer.scss';

export const ClDrawerLeft: FC = () => {
  return (
    <Container data-aos="fade-in" fluid className="cl-drawer cl-drawer-left">
      <div className="cl-drawer-left__container">
        <div className="item">
          <a
            href="https://github.com/nhanlnt-96"
            target="_blank"
            rel="noreferrer"
          >
            <FiGithub />
          </a>
        </div>
        <div className="item">
          <a
            href="https://www.linkedin.com/in/nhanlnt/"
            target="_blank"
            rel="noreferrer"
          >
            <FiLinkedin />
          </a>
        </div>
      </div>
    </Container>
  );
};
